// Device Fingerprinting Utility for Frontend
export const generateDeviceFingerprint = async () => {
  const fingerprint = {
    canvas: null,
    fonts: [],
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    platform: navigator.platform,
    plugins: []
  };

  // Canvas fingerprinting
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device fingerprint', 2, 2);
    fingerprint.canvas = canvas.toDataURL();
  } catch (e) {
    // Canvas not available
  }

  // Font detection (basic)
  const baseFonts = ['monospace', 'sans-serif', 'serif'];
  const testString = 'mmmmmmmmmmlli';
  const testSize = '72px';
  const h = document.getElementsByTagName('body')[0];
  const s = document.createElement('span');
  s.style.fontSize = testSize;
  s.innerHTML = testString;
  const defaultWidth = {};
  const defaultHeight = {};

  for (let i = 0; i < baseFonts.length; i++) {
    s.style.fontFamily = baseFonts[i];
    h.appendChild(s);
    defaultWidth[baseFonts[i]] = s.offsetWidth;
    defaultHeight[baseFonts[i]] = s.offsetHeight;
    h.removeChild(s);
  }

  // Detect available fonts
  const detectedFonts = [];
  const testFonts = ['Arial', 'Verdana', 'Times New Roman', 'Courier New', 'Georgia', 'Palatino', 'Garamond', 'Bookman', 'Comic Sans MS', 'Trebuchet MS', 'Arial Black', 'Impact'];
  
  for (let i = 0; i < testFonts.length; i++) {
    let detected = false;
    for (let j = 0; j < baseFonts.length; j++) {
      s.style.fontFamily = testFonts[i] + ',' + baseFonts[j];
      h.appendChild(s);
      const matched = (s.offsetWidth !== defaultWidth[baseFonts[j]] || s.offsetHeight !== defaultHeight[baseFonts[j]]);
      h.removeChild(s);
      if (matched) {
        detected = true;
        break;
      }
    }
    if (detected) {
      detectedFonts.push(testFonts[i]);
    }
  }

  fingerprint.fonts = detectedFonts;

  // Plugin detection
  if (navigator.plugins) {
    for (let i = 0; i < navigator.plugins.length; i++) {
      fingerprint.plugins.push(navigator.plugins[i].name);
    }
  }

  return fingerprint;
};


